<template>
  <v-menu v-model="isOpenDropDown" :close-on-content-click="true" offset-y>
    <template #activator="{ props }">
      <div 
        v-bind="props" 
        :class="frontStyle === 'discord' ? 'discord-project-name' : 'classic-project-name'"
      >
        {{ projectName }}
        <v-icon v-if="frontStyle === 'discord'" class="ml-2">mdi-chevron-down</v-icon>
      </div>
    </template>
    <v-list>
      <v-list-item @click="showAddUserWindow = true">
        <v-list-item-title><v-icon>mdi-account-plus</v-icon> Añadir usuario</v-list-item-title>
      </v-list-item>
      <v-list-item v-if="project.options?.isAgile" @click="newSprintDialog = true">
        <v-list-item-title><v-icon>mdi-jira</v-icon> Crear sprint</v-list-item-title>
      </v-list-item>
      <v-list-item v-if="project.options?.hasSubprojects" @click="newSubprojectDialog = true">
        <v-list-item-title><v-icon>mdi-folder</v-icon> Crear {{ project.subprojectName || 'subproyecto' }}</v-list-item-title>
      </v-list-item>
      <v-list-item @click="editarProyecto">
        <v-list-item-title><v-icon>mdi-pencil</v-icon> Editar aplicación</v-list-item-title>
      </v-list-item>
      <v-list-item @click="showProfile = true">
        <v-list-item-title><v-icon>mdi-account</v-icon> Perfil</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
  <!-- Modales flotantes -->
  <NewMemberComponent v-model:dialog="showAddUserWindow" />
  <NewSprint v-model:dialog="newSprintDialog" v-if="newSprintDialog" />
  <NewSubproject v-model:dialog="newSubprojectDialog" v-if="newSubprojectDialog" />
  <UserProfile v-if="showProfile" v-model:dialog="showProfile" style="position: fixed;"/>
</template>

<script>
import NewMemberComponent from '../NewMemberComponent.vue';
import NewSprint from '../NewSprint.vue';
import NewSubproject from '../modals/NewSubproject.vue';
import UserProfile from './UserProfile.vue';
export default {
  name: "AppDropdown",
  components: {
    NewMemberComponent,
    NewSprint,
    NewSubproject,
    UserProfile
  },
  props: {
    frontStyle: {
      type: String,
      default: 'classic'
    }
  },
  computed: {
    project() {
      return this.$store.state.project;
    },
    projectName(){
      const project = this.project;
      return (project?.name && project?.name?.length > 12)
          ? project.name.substring(0, 20) + '...'
          : project?.name || 'Proyecto';
    }
  },
  data() {
    return {
      isOpenDropDown: false,
      showAddUserWindow: false,
      newSprintDialog: false,
      newSubprojectDialog: false,
      showProfile: false
    }
  },
  methods: {
    editarProyecto() {
      sessionStorage.setItem('project_edit', JSON.stringify(this.$store.state.project));
      this.$router.push({
        name: "CMSEdit",
        params: {
          projectId: this.$route.params.projectId
        }
      })
    },
  }
}
</script>

<style scoped>
.discord-project-name {
  font-size: 1.5em;
  cursor: pointer;
  padding: 10px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  border-radius: 5px;
  user-select: none;
  white-space: wrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: rgba(0,0,0,0.1);
}

.classic-project-name {
  background-color: rgba(0,0,0,0.1);
  width: 350px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  user-select: none;
  border-radius: 5px;
}
</style>